import { render, staticRenderFns } from "./AddValue.vue?vue&type=template&id=0a704392&scoped=true&"
import script from "./AddValue.vue?vue&type=script&lang=js&"
export * from "./AddValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a704392",
  null
  
)

export default component.exports